export const NEW_MESSAGE = 'NEW_MESSAGE';
export const AREA_CHANNEL = 'AREA_CHANNEL';